import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { errorHandler } from "apiHelpers/api/errorHandler";

//actions
import { LoyaltyAction, NotPersistAction, ErrorAction, CartAction} from "store/actions";


import { usePlaceMyOrderMutation } from "store/checkout/order/orderService";
import { logErrorOnSentry } from "utils/Utils";

import C from "Constants";
import { UTILS } from "utils";
import {
  validateBrandOrderObject,
  getBrandBasedOrderObject,
} from "utils/OrderUtils";

function usePlaceOrderHelper(handleSuceessOrderRoute) {
  const dispatch = useDispatch();
  const { orderId, orderNumber, dineInTableNumber, dineInServiceFee } = useSelector((state) => state.cart);
  const [placeMyOrder] = usePlaceMyOrderMutation();

  const PLACE_order = async (obj) => {
    try {
      const updatedObj = {...obj}
      if(obj?.orderType?.type === C.SERVICE_TYPE.DINE_IN){
        updatedObj.orderId = orderId;
        updatedObj.orderNumber = orderNumber;
        updatedObj.dineInTableNumber = dineInTableNumber;
        updatedObj.isDineIn = true;
        updatedObj.dineInServiceFee = dineInServiceFee;
      }
      const { data, error } = await placeMyOrder(updatedObj);
      dispatch(CartAction.clearCart());
      if (data?.success === 1 && data?.data?.savedOrder?.orderNumber) {
        dispatch(LoyaltyAction.removeLoyalty());
        const orderNumber = data?.data?.savedOrder?.orderNumber;
        handleSuceessOrderRoute(orderNumber);
      }else if(data?.success === 1){
        dispatch(LoyaltyAction.removeLoyalty());
        handleSuceessOrderRoute();
      } else {
        let message = error ? error?.data ||  error?.error?.message : data ? data?.message  : null
        dispatch(NotPersistAction.toggleOrderPlaceModel(false));
        logError(message || t(C.DEFAULT_ERROR_MSG), true, "error");
        return;
      }
    } catch (error) {
      console.log("error order place helper", error);
      logError(error?.error?.message || t(C.DEFAULT_ERROR_MSG), true, "error");
    }
  };

  const outlet_based_place_order = async (paymentObj = null) => {
    const { orderObject, isValid, errors } = UTILS.validateOutletOrderObject();
    if (!isValid) {
      showErrors(errors);
      return;
    }
    orderObject.transactionInfo = paymentObj?.paymentIntent;
    const orderobj = UTILS.getOutletOrderObject(orderObject);
    PLACE_order(orderobj);
  };

  const showErrors = (errors) => {
    const error = Object.values(errors).find((value) => value !== null);
    if (error) {
      logError(errorHandler(error), true, "error");
    }
  };

  const logError = (msg, modal, level) => {
    dispatch(
      ErrorAction.setError({
        error: msg,
        modal: modal,
      })
    );
    if (msg && msg !== C.DEFAULT_ERROR_MSG) {
      logErrorOnSentry(msg, level);
    }
  };

  // const validateSavedCard = (cardType, selectedCard) => {
  //   if (
  //     selectedCard?.cardInfo?._id &&
  //     selectedCard?.cardInfo?.paymentGateway === cardType
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };
  const brand_based_place_order = async (paymentObj = null) => {
    const { errors, isValid, obj } = await validateBrandOrderObject();
    if (!isValid) {
      showErrors(errors);
      return;
    }
    obj.transactionInfo = paymentObj?.paymentIntent;
    const orderObject = getBrandBasedOrderObject(obj);
    PLACE_order(orderObject);
  };
  return {
    PLACE_order,
    outlet_based_place_order,
    brand_based_place_order,
    logError,
  };
}

export default usePlaceOrderHelper;
